export const environment = {
  production: true,
  authentication: { ClienteId: 'WAREHOUSEJS', SistemaId: 'c3fe7efa-92aa-4c57-97cf-1aff1d3aa4f6', Stage: false, Scenario1: true },
  fileshare: { CodigoSistema: 20 },
  firebase: {
    apiKey: "AIzaSyBjL-rC_5Uy6kSfCuLhx8qeQXus3z-4IKk",
    databaseURL: "https://notificacionpush-b6f72.firebaseio.com",
    messagingSenderId: "768015207056",
    projectId: "notificacionpush-b6f72",
    appId: "1:768015207056:web:4db85ed948b82eb4",
    PublicVapidKey: "BPIMAR3t8i9BhCR68_5B5vDXyX6fp_315-NLO_XDmcQjDgJMXj9MDSNZ6pV8ZWQmVeicG9Zvp5BD7LPqBM_pYq4",
    SistemaId: 'd5375da8-0e2d-4dfb-8b01-199ac729ac77'
  },
  webServices: {
    WareHouse: 'https://scewarehouseapi.vestadev-accelerate.com/api/'
  },
  web: {
    Remisiones: 'https://scecontroldedocumentosweb.vestadev-accelerate.com/remisiones/',
    ModeloLogistico: 'https://scemodelologisticoderedopeweb.vestadev-accelerate.com/GestionUnica?codigoGestion='
  }
};
